'use strict';
var store = require('../internals/shared-store');

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/shared.js
// module id = 133
// module chunks = 22